function getQueryParams(queryString) {
    let query = {};
    if (queryString) {
        queryString.substring(1).split('&').forEach((queryItem) => {
            let queryArray = queryItem.split('=');
            query[queryArray[0]] = decodeURIComponent(queryArray[1]);
        });
    }

    return query;
}

export {getQueryParams};
